import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const resumenInsumosPdf = (data) => {
  const { empresa, folio, fecha, cliente, rfc, insumos } = data;

  const celdaDerechaHeader = {
    border: [false, false, false, false],
    table: {
      widths: ["100%"],
      body: [
        [
          {
            text: "Resumen de Insumos",
            bold: true,
            fontSize: 11,
            alignment: "left",
            margin: [0, 0, 0, 4],
          },
        ],
        [{ text: "Folio: " + folio, style: "subheader", alignment: "left" }],
        [
          {
            text: "Fecha: " + moment(fecha).format("DD/MM/YYYY"),
            style: "subheader",
            alignment: "left",
          },
        ],
        [
          {
            text: "Cliente: " + cliente,
            style: "subheader",
            alignment: "left",
          },
        ],
        [{ text: "RFC: " + rfc, style: "subheader", alignment: "left" }],
      ],
    },
    layout: "noBorders",
  };

  const titulo = [
    { text: "#", style: "tituloTabla" },
    { text: "Insumo", style: "tituloTabla" },
    { text: "Cantidad", style: "tituloTabla" },
    { text: "Apartado", style: "tituloTabla" },
    { text: "Requerido", style: "tituloTabla" },
    { text: "Restante", style: "tituloTabla" },
  ];

  const filas = insumos.map((insumo, index) => {
    const cantidad = Number(insumo.cantidad || 0);
    const apartado = Number(insumo.apartado || 0);
    const requerido = Number(insumo.requerido || 0);
    const restante = Math.max(0, cantidad - apartado - requerido);

    return [
      { text: index + 1, style: "textoTablaChico", alignment: "center" },
      { text: insumo.nombre, style: "textoTablaChico", alignment: "left" },
      { text: cantidad, style: "textoTablaChico", alignment: "right" },
      { text: apartado, style: "textoTablaChico", alignment: "right" },
      { text: requerido, style: "textoTablaChico", alignment: "right" },
      {
        text: restante,
        style: "textoTablaChico",
        alignment: "right",
        color: restante === 0 && cantidad > 0 ? "#d32f2f" : "#000000",
      },
    ];
  });

  return {
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: { defaultBorder: false },
          body: [
            [...HeaderEmpresaCard(empresa, true, false, celdaDerechaHeader)],
          ],
        },
      },
      {
        text: "Detalle de Insumos",
        style: "title",
        margin: [0, 6, 0, 4],
      },
      {
        style: "tableExample",
        table: {
          widths: ["4%", "46%", "12%", "12%", "13%", "13%"],
          body: [titulo, ...filas],
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff"),
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
          hLineStyle: (i, node) =>
            i === 0 || i === node.table.body.length
              ? null
              : { dash: { length: 2, space: 1 } },
          vLineStyle: (i, node) =>
            i === 0 || i === node.table.widths.length
              ? null
              : { dash: { length: 2 } },
        },
      },
      {
        text: "Generado el " + moment().format("DD/MM/YYYY HH:mm"),
        style: "textoChicoData",
        alignment: "right",
        margin: [0, 8, 0, 0],
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: {
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      title: { bold: true, fontSize: 16, color: "black", alignment: "left" },
      textoChicoData: { fontSize: 6 },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        alignment: "center",
      },
      textoTablaChico: { fontSize: 7, italics: false },
    },
    pageSize: "LETTER",
  };
};

export default resumenInsumosPdf;
